export const getQueryParam = (appliedFilter) => {
  // const queryStr = '';
  // const isFirst = true;
  const params = new URLSearchParams(appliedFilter);
  const keysForDel = [];
  params.forEach((v, k) => {
    if (!v) { keysForDel.push(k); }
  });
  keysForDel.forEach((k) => {
    params.delete(k);
  });

  const queryStr = params.toString();

  return queryStr ? (`?${queryStr}`) : '';
};
